import { gql } from 'urql';

const FetchPayOverTimeManualPaymentDetails = gql`
  query PayOverTimeManualPaymentDetails($loanId: ID!) {
    payOverTimeManualPaymentDetails(loanId: $loanId) {
      __typename
      ... on PayOverTimeManualPaymentDetailSuccess {
        fromAccountSelectorView {
          accountId
          accountNumber
          accountNumberLast4
          iconURL
          name
          nickname
          availableBalance {
            amount
            currency
            formatted
            formattedWithPlusPrefix
            formattedWithPlusPrefixOrAbs
          }
        }
        payOverTimeLoanPaymentView {
          dueDate
          loanId
          outstandingBalance {
            amount
            currency
            formatted
            formattedWithPlusPrefix
            formattedWithPlusPrefixOrAbs
          }
          prepopulatedPaymentAmount {
            amount
            currency
            formatted
            formattedWithPlusPrefix
            formattedWithPlusPrefixOrAbs
          }
        }
      }
      ... on PayOverTimeManualPaymentDetailError {
        code
        message
        title
      }
    }
  }
`;

export default FetchPayOverTimeManualPaymentDetails;
